import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiResponse,
  DictionaryField,
  DictionaryFieldFromApi,
  PaidCategory,
  PaidCategoryFromApi,
} from '@gk/gk-modules';
import { map, Observable, shareReplay } from 'rxjs';

@Injectable()
export class PublicRegisterService {
  private publicRegisters: Observable<DictionaryField[]>;
  private dataBaseGml: Observable<PaidCategory[]>;

  constructor(private httpClient: HttpClient) {}

  public getPublicRegisters(): Observable<DictionaryField[]> {
    if (!this.publicRegisters) {
      this.publicRegisters = this.httpClient
        .get<
          ApiResponse<DictionaryFieldFromApi[]>
        >('/api/interesant/slo/rej/publ')
        .pipe(
          map((data) => data.Response),
          map((publicRegisters) =>
            publicRegisters.map((publicRegister) =>
              DictionaryField.fromApiToApp(publicRegister),
            ),
          ),
          shareReplay(1),
        );
    }

    return this.publicRegisters;
  }

  public getDataBaseGml(): Observable<PaidCategory[]> {
    if (!this.dataBaseGml) {
      this.dataBaseGml = this.httpClient
        .get<
          ApiResponse<PaidCategoryFromApi[]>
        >('/api/interesant/przp/slo/cenpozycja')
        .pipe(
          map((data) => data.Response),
          map((items) =>
            items.map((item) => PaidCategory.fromApiToApp(item, false)),
          ),
          shareReplay(1),
        );
    }

    return this.dataBaseGml;
  }
}
